<template>
    <div>
        <kgr-loading
            v-if="loading"
            inline
        />
        <div v-else>
            <div class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                {{ $t('Club.memberRegistration') }}
            </div>

            <div class="kgr-row">
                <kgr-form-row
                    :label="$t('club_application_configuration_active')"
                    :error="error"
                    field-name="active"
                >
                    <kgr-checkbox
                        v-model="clubApplicationSettings.active"
                        :label="$t('club_application_configuration_active')"
                    />
                </kgr-form-row>
            </div>

            <div
                v-if="clubApplicationSettings.active"
                class="kgr-row"
            >
                <kgr-form-row
                    :label="$t('club.member.application.configuration.integration')"
                    :error="error"
                    field-name="none"
                >
                    <kgr-text-input
                        :value="iFrameRoute"
                        disabled
                    />
                </kgr-form-row>
            </div>

            <kgr-accordion
                v-if="clubApplicationSettings.active"
            >
                <kgr-accordion-item :title="titles['intro']">
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Einleitung (bis zu 1.000 Zeichen)')"
                            :error="error"
                            field-name="welcomeIntro"
                        >
                            <kgr-editor-mini
                                v-model="clubApplicationSettings.welcomeIntro"
                                editor-id="welcome"
                                height="150"
                            />
                        </kgr-form-row>
                    </div>
                </kgr-accordion-item>
                <kgr-accordion-item :title="titles['details']">
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Einleitung (bis zu 1.000 Zeichen)')"
                            :error="error"
                            field-name="detailsIntro"
                        >
                            <kgr-editor-mini
                                v-model="clubApplicationSettings.detailsIntro"
                                editor-id="details"
                                height="150"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Titel')"
                            :error="error"
                            field-name="askTitle"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askTitle"
                                :label="$t('Soll der akademische Titel abgefragt werden?')"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <div style="margin-top: 10px;">
                            <kgr-dropdown
                                v-model="legalRepresentativeAgeLimit"
                                :label="$t('Unterhalb welchen Alters ist ein gesetzlicher Vertreter erforderlich?')"
                                display="name"
                                :options="ageLimitOptions"
                                @post-input="element => updateLegalRepresentativeAgeLimit(element)"
                            />
                        </div>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Vertragsstatus')"
                            :error="error"
                            field-name="askPassiveContractState"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askPassiveContractState"
                                :label="$t('Soll auch die Passive Mitgliedschaft als Vertragstyp auswählbar sein?')"
                            />
                        </kgr-form-row>
                    </div>
                </kgr-accordion-item>
                <kgr-accordion-item :title="titles['contactDetails']">
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Einleitung (bis zu 1.000 Zeichen)')"
                            :error="error"
                            field-name="contactIntro"
                        >
                            <kgr-editor-mini
                                v-model="clubApplicationSettings.contactIntro"
                                editor-id="contact"
                                height="150"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Telefonnummer geschäftlich')"
                            :error="error"
                            field-name="askBusinessPhone"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askBusinessPhone"
                                :label="$t('Telefonnummer geschäftlich abfragen?')"
                            />
                        </kgr-form-row>
                        <kgr-form-row
                            :label="$t('Handynummer geschäftlich')"
                            :error="error"
                            field-name="askBusinessMobile"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askBusinessMobile"
                                :label="$t('Handynummer geschäftlich abfragen?')"
                            />
                        </kgr-form-row>
                        <kgr-form-row
                            :label="$t('Firma')"
                            :error="error"
                            field-name="askCompanyName"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askCompanyName"
                                :label="$t('club.member.application.configuration.askCompanyNameCheckbox')"
                            />
                        </kgr-form-row>
                        <kgr-form-row
                            :label="$t('C/O Adressfeld')"
                            :error="error"
                            field-name="askCOAddress"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askCOAddress"
                                :label="$t('club.member.application.configuration.askCOAddressCheckbox')"
                            />
                        </kgr-form-row>
                    </div>
                </kgr-accordion-item>
                <kgr-accordion-item
                    v-if="isDogModuleActive"
                    :title="titles['dogs']"
                >
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Einleitung (bis zu 1.000 Zeichen)')"
                            :error="error"
                            field-name="dogsIntro"
                        >
                            <kgr-editor-mini
                                v-model="clubApplicationSettings.dogsIntro"
                                editor-id="dogs"
                                height="150"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            v-model="clubApplicationSettings.askDogs"
                            :label="$t('Hunde abfragen?')"
                            :error="error"
                            field-name="askDogs"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askDogs"
                                :label="$t('Hunde abfragen?')"
                            />
                        </kgr-form-row>
                        <kgr-form-row
                            v-model="clubApplicationSettings.askDogMandatory"
                            :label="$t('Eingabe von Hunden verpflichtend?')"
                            :error="error"
                            field-name="askDogMandatory"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askDogMandatory"
                                :label="$t('Eingabe von Hunden verpflichtend?')"
                            />
                        </kgr-form-row>
                        <kgr-form-row
                            v-model="clubApplicationSettings.askDogChipNumberMandatory"
                            :label="$t('Chipnummer verpflichtend?')"
                            :error="error"
                            field-name="askDogChipNumberMandatory"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askDogChipNumberMandatory"
                                :label="$t('Chipnummer verpflichtend?')"
                            />
                        </kgr-form-row>
                        <kgr-form-row
                            :label="$t('Zuchtbuchnummer verpflichtend?')"
                            :error="error"
                            field-name="askDogBreedingBookNumberMandatory"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askDogBreedingBookNumberMandatory"
                                :label="$t('Zuchtbuchnummer verpflichtend?')"
                            />
                        </kgr-form-row>
                    </div>
                </kgr-accordion-item>
                <kgr-accordion-item :title="titles['contractDetails']">
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Einleitung (bis zu 1.000 Zeichen)')"
                            :error="error"
                            field-name="contractIntro"
                        >
                            <kgr-editor-mini
                                v-model="clubApplicationSettings.contractIntro"
                                editor-id="contract"
                                height="150"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Abteilungen')"
                            :error="error"
                            field-name="askDepartments"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askDepartments"
                                :label="$t('Abteilungen dürfen ausgewählt werden (an der jeweiligen Abteilung einzustellen)')"
                            />
                        </kgr-form-row>
                    </div>
                </kgr-accordion-item>

                <kgr-accordion-item :title="titles['fileUpload']">
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Einleitung (bis zu 1.000 Zeichen)')"
                            :error="error"
                            field-name="fileUploadIntro"
                        >
                            <kgr-editor-mini
                                v-model="clubApplicationSettings.fileUploadIntro"
                                editor-id="fileUpload"
                                height="150"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Datenupload')"
                            :error="error"
                            field-name="allowDataUpload"
                        >
                            <div class="mb-2">
                                <kgr-checkbox
                                    v-model="clubApplicationSettings.allowDataUpload"
                                    :label="$t('Soll das Mitglied Dateien hochladen können?')"
                                />
                            </div>
                            <div
                                v-if="clubApplicationSettings.allowDataUpload"
                                class="mb-2 left-space"
                                style="margin-top: 10px;"
                            >
                                <kgr-text-input
                                    v-model.trim="clubApplicationSettings.dataUploadDescription"
                                    :label="$t('Was soll beim Datenupload stehen?')"
                                    :placeholder="$t('Hier kannst du uns Dateien zur Verfügung stellen.')"
                                    :disabled="!clubApplicationSettings.allowDataUpload"
                                />
                            </div>
                        </kgr-form-row>
                    </div>
                </kgr-accordion-item>
                <kgr-accordion-item
                    :title="titles['paymentDetails']"
                    :has-error="paymentAccordionHasError"
                >
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Einleitung (bis zu 1.000 Zeichen)')"
                            :error="error"
                            field-name="paymentIntro"
                        >
                            <kgr-editor-mini
                                v-model="clubApplicationSettings.paymentIntro"
                                editor-id="payment"
                                height="150"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Eintrittsdatum')"
                            :error="error"
                            field-name="askContractStart"
                        >
                            <div class="mb-2">
                                <kgr-checkbox
                                    v-model="clubApplicationSettings.askContractStart"
                                    :label="$t('Es darf ein gewünschtes Einrittsdatum angegeben werden.')"
                                />
                            </div>
                            <div
                                v-if="clubApplicationSettings.askContractStart"
                                class="left-space"
                            >
                                <div class="mb-2">
                                    <kgr-checkbox
                                        v-model="clubApplicationSettings.askContractStartMandatory"
                                        :label="$t('Die Eingabe ist verpflichtend.')"
                                    />
                                </div>
                                <div class="mb-2">
                                    <kgr-checkbox
                                        v-model="clubApplicationSettings.canContractStartBeInPast"
                                        :label="$t('Darf das Eintrittsdatum auch in der Vergangenheit liegen?')"
                                        :inactive="!clubApplicationSettings.askContractStart"
                                        :readonly="!clubApplicationSettings.askContractStart"
                                    />
                                </div>
                                <div class="mb-2">
                                    <kgr-checkbox
                                        v-model="clubApplicationSettings.contractStartOnlyMonthly"
                                        :label="$t('Eintrittsdatum nur monatlich')"
                                        :inactive="!clubApplicationSettings.askContractStart"
                                        :readonly="!clubApplicationSettings.askContractStart"
                                        @change="(value) => value && clubApplicationSettings.contractStartOnlyQuarterly ? clubApplicationSettings.contractStartOnlyQuarterly = false : null"
                                    />
                                </div>
                                <div class="mb-2">
                                    <kgr-checkbox
                                        v-model="clubApplicationSettings.contractStartOnlyQuarterly"
                                        :label="$t('Eintrittsdatum nur quartalsweise')"
                                        :inactive="!clubApplicationSettings.askContractStart"
                                        :readonly="!clubApplicationSettings.askContractStart"
                                        @change="(value) => value && clubApplicationSettings.contractStartOnlyMonthly ? clubApplicationSettings.contractStartOnlyMonthly = false : null"
                                    />
                                </div>
                            </div>
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Zahlarten')"
                            :error="error"
                            field-name="allowInvoicePayment"
                        >
                            <div class="mb-2">
                                <kgr-checkbox
                                    v-model="clubApplicationSettings.allowInvoicePayment"
                                    :label="$t('Zahlart Rechnung anbieten?')"
                                />
                            </div>
                            <div class="mb-2">
                                <kgr-checkbox
                                    v-model="clubApplicationSettings.allowSEPAPayment"
                                    :label="$t('Zahlart SEPA-Lastschrift anbieten (und entsprechende Daten abfragen)?')"
                                />
                            </div>
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Zahlungsintervall')"
                            :error="error"
                            field-name="allowPaymentIntervalSelection"
                        >
                            <div class="mb-2">
                                <kgr-checkbox
                                    v-model="clubApplicationSettings.allowPaymentIntervalSelection"
                                    :label="$t('Zahlungsintervalle anbieten')"
                                    @change="paymentIntervalChanged()"
                                />
                            </div>
                            <div
                                v-if="clubApplicationSettings.allowPaymentIntervalSelection"
                                class="left-space"
                            >
                                <div class="mb-2">
                                    <kgr-checkbox
                                        v-model="clubApplicationSettings.allowMonthlyPaymentInterval"
                                        :label="$t('Monatlich anbieten')"
                                        :inactive="!clubApplicationSettings.allowPaymentIntervalSelection"
                                        :readonly="!clubApplicationSettings.allowPaymentIntervalSelection"
                                        @change="paymentIntervalChanged()"
                                    />
                                </div>
                                <div class="mb-2">
                                    <kgr-checkbox
                                        v-model="clubApplicationSettings.allowQuarterlyPaymentInterval"
                                        :label="$t('Quartalsweise anbieten')"
                                        :inactive="!clubApplicationSettings.allowPaymentIntervalSelection"
                                        :readonly="!clubApplicationSettings.allowPaymentIntervalSelection"
                                        @change="paymentIntervalChanged()"
                                    />
                                </div>
                                <div class="mb-2">
                                    <kgr-checkbox
                                        v-model="clubApplicationSettings.allowHalfYearlyPaymentInterval"
                                        :label="$t('Halbjährlich anbieten')"
                                        :inactive="!clubApplicationSettings.allowPaymentIntervalSelection"
                                        :readonly="!clubApplicationSettings.allowPaymentIntervalSelection"
                                        @change="paymentIntervalChanged()"
                                    />
                                </div>
                                <div class="mb-2">
                                    <kgr-checkbox
                                        v-model="clubApplicationSettings.allowYearlyPaymentInterval"
                                        :label="$t('Jährlich anbieten')"
                                        :inactive="!clubApplicationSettings.allowPaymentIntervalSelection"
                                        :readonly="!clubApplicationSettings.allowPaymentIntervalSelection"
                                        @change="paymentIntervalChanged()"
                                    />
                                </div>
                            </div>
                        </kgr-form-row>
                    </div>
                    <div class="mb-2">
                        {{ $t('club.member.application.configuration.urlInfos') }}
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Datenschutzrichtlinien')"
                            :error="error"
                            field-name="dataProtectionUrl"
                        >
                            <kgr-text-input
                                v-model.trim="clubApplicationSettings.dataProtectionUrl"
                                placeholder="https://www.deineurl.de"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Vereinssatzung')"
                            :error="error"
                            field-name="statuteUrl"
                        >
                            <kgr-text-input
                                v-model.trim="clubApplicationSettings.statuteUrl"
                                placeholder="https://www.deineurl.de"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Beitragsordnung')"
                            :error="error"
                            field-name="contributionRegulationsUrl"
                        >
                            <kgr-text-input
                                v-model.trim="clubApplicationSettings.contributionRegulationsUrl"
                                placeholder="https://www.deineurl.de"
                            />
                        </kgr-form-row>
                    </div>
                </kgr-accordion-item>
                <kgr-accordion-item :title="titles['moreDetails']">
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Einleitung (bis zu 1.000 Zeichen)')"
                            :error="error"
                            field-name="otherIntro"
                        >
                            <kgr-editor-mini
                                v-model="clubApplicationSettings.otherIntro"
                                editor-id="other"
                                height="150"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Notfallkontaktdaten (Freitextfeld)')"
                            :error="error"
                            field-name="askEmergencyContact"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askEmergencyContact"
                                :label="$t('Sollen Notfallkontaktdaten abgefragt werden?')"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Familienmitglieder')"
                            :error="error"
                            field-name="askFamilyMembers"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askFamilyMembers"
                                :label="$t('club.member.application.configuration.askFamilyMembersCheckbox')"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-row">
                        <kgr-form-row
                            :label="$t('Zusatzinformationen')"
                            :error="error"
                            field-name="askAdditionalInformation"
                        >
                            <kgr-checkbox
                                v-model="clubApplicationSettings.askAdditionalInformation"
                                :label="$t('Soll ein Freitextfeld “Zusatzinformationen” angezeigt werden?')"
                            />
                        </kgr-form-row>
                    </div>


                    <kgr-form-row
                        :label="$t('Sortier- und Auswahlkriterien, die bei der Anmeldung abgefragt werden sollen')"
                        :error="error"
                        :tooltip="$t('Hinweis: Welche Sortier- und Auswahlkriterien hier zur Auswahl stehen, wird über die Formularvorgaben für Mitglieder definiert.')"
                        field-name="askAdditionalInformation"
                    >
                        <div class="kgr-row" v-for="(memberFilterFlag,index) in clubApplicationSettings.memberFilterFlags" :key="index">
                            <kgr-checkbox
                                v-model="clubApplicationSettings.memberFilterFlags[index].checked"
                                :label="memberFilterFlag.name"
                            />
                        </div>
                    </kgr-form-row>

                    <kgr-form-row
                        :label="$t('Zuordnungen, die bei der Anmeldung abgefragt werden sollen')"
                        :error="error"
                        :tooltip="$t('Hinweis: Welche Zuordnungen hier zur Auswahl stehen, wird über die Formularvorgaben für Mitglieder definiert.')"
                        field-name="askAdditionalInformation"
                    >
                        <div class="kgr-row" v-for="(memberClassification,index) in clubApplicationSettings.memberClassifications" :key="index">
                            <kgr-checkbox
                                v-model="clubApplicationSettings.memberClassifications[index].checked"
                                :label="memberClassification.name"
                            />
                        </div>
                    </kgr-form-row>
                </kgr-accordion-item>
            </kgr-accordion>

            <div
                v-if="isEditable"
                class="kgr-text kgr-text--rightAligned mt1"
            >
                <kgr-button
                    :value="$t('Speichern')"
                    @click="save()"
                />
            </div>
        </div>
    </div>
</template>

<script>

import Accordion from '../../../../components/common/accordion/Accordion.vue';
import AccordionItem from '../../../../components/common/accordion/AccordionItem.vue';
import Checkbox from '../../../../components/common/form/checkbox/Checkbox.vue';
import ClubApplicationSettingRepository from '../../../../js/repository/ClubApplicationSettingRepository';
import Dropdown from '../../../../components/common/form/select/Dropdown.vue';
import Error from '../../../../js/model/Error';
import FormRow from '../../../../components/common/form/FormRow.vue';
import KgrButton from '../../../../components/common/form/button/KgrButton.vue';
import Loading from '../../../../components/common/Loading';
import TextInput from '../../../../components/common/form/text-input/TextInput.vue';
import WysiwygEditorMini from '../../../../components/WysiwygEditorMini.vue';

export default {
    components: {
        'kgr-editor-mini': WysiwygEditorMini,
        'kgr-loading': Loading,
        'kgr-checkbox': Checkbox,
        'kgr-dropdown': Dropdown,
        'kgr-text-input': TextInput,
        'kgr-button': KgrButton,
        'kgr-form-row': FormRow,
        'kgr-accordion': Accordion,
        'kgr-accordion-item': AccordionItem
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        clubBaseUrl: {
            type: String,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDogModuleActive: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            clubApplicationSettings: null,
            error: new Error(),
            ageLimitOptions: [
                {name: 'U14', value: 14},
                {name: 'U15', value: 15},
                {name: 'U16', value: 16},
                {name: 'U17', value: 17},
                {name: 'U18', value: 18},
            ],
            legalRepresentativeAgeLimit: null,
            paymentAccordionHasError: false,
            titles: {
                'intro': this.$t('{order} Willkommensseite', {order: 0}),
                'details': this.$t('{order} Personen anmelden', {order: 1}),
                'contactDetails': this.$t('{order} Persönliche Daten', {order: 2}),
                'dogs': this.$t('{order} Hunde', {order: 3}),
                'contractDetails': this.$t('{order} Abteilungen', {order: (this.isDogModuleActive ? 4 : 3)}),
                'fileUpload': this.$t('{order} Datei-Upload', {order: (this.isDogModuleActive ? 5 : 4)}),
                'paymentDetails': this.$t('{order} Zahlungsdaten', {order: (this.isDogModuleActive ? 6 : 5)}),
                'moreDetails': this.$t('{order} Weitere Informationen', {order: (this.isDogModuleActive ? 7 : 6)}),
            }
        };
    },
    computed: {
        iFrameRoute() {
            return `${this.clubBaseUrl}/anmeldung/${this.clubId}`;
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            this.loading = true;
            ClubApplicationSettingRepository.find(this.clubId)
                .then(clubApplicationSettings => {
                    this.clubApplicationSettings = clubApplicationSettings;
                    if (clubApplicationSettings.legalRepresentativeAgeLimit) {
                        this.legalRepresentativeAgeLimit = this.ageLimitOptions.find(e => e.value === clubApplicationSettings.legalRepresentativeAgeLimit);
                    }
                })
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        save() {
            this.error = new Error();
            this.paymentAccordionHasError = false;
            ClubApplicationSettingRepository.update(this.clubId, this.clubApplicationSettings)
                .then(() => this.$notify.success('Die Änderungen wurden erfolgreich gespeichert.'))
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('Die Änderungen konnten nicht gespeichert werden.');
                    if (error.forField('allowInvoicePayment')) {
                        this.paymentAccordionHasError = true;
                    }
                });
        },
        paymentIntervalChanged() {
            this.error.clear('allowPaymentIntervalSelection');
            if (this.clubApplicationSettings.allowPaymentIntervalSelection &&
                !this.clubApplicationSettings.allowMonthlyPaymentInterval &&
                !this.clubApplicationSettings.allowQuarterlyPaymentInterval &&
                !this.clubApplicationSettings.allowHalfYearlyPaymentInterval &&
                !this.clubApplicationSettings.allowYearlyPaymentInterval)  {
                this.error.add('allowPaymentIntervalSelection', this.$t('Bitte mindestens ein Zahlungsintervall auswählbar machen.'));
            }
        },
        updateLegalRepresentativeAgeLimit(element) {
            if (element) {
                this.clubApplicationSettings.legalRepresentativeAgeLimit = element.value;
            } else {
                this.clubApplicationSettings.legalRepresentativeAgeLimit = null;
            }
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .left-space {
        margin-left: 30px;
    }
</style>
